import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import { Box, Divider, Chip, Breadcrumbs, Typography } from "@mui/material";
import BASE_API_URL from "../../apis/index";
import "bootstrap/dist/css/bootstrap.min.css";
import UserStatsSec from "./AdminUserDetails/UserStatsSec";
import UserCompShortDetails from "./AdminUserDetails/UserCompShortDetails";

export default function AdminUserDetails() {
  const [userData, setUserData] = useState(null);

  // ✅ Read URL query param
  const useQuery = () => new URLSearchParams(useLocation().search);
  const userId = useQuery().get("userId");

  console.log(userId);


  useEffect(() => {
    async function fetchUserDetails() {
      try {
        const authToken = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_API_URL}/api/admin/user-details/${userId}`,
          { headers: { Authorization: `Bearer ${authToken}` } }
        );

        setUserData(res.data);
        console.log(res.data);

      } catch (err) {
        console.error("Failed to fetch user details", err);
      }
    }
    fetchUserDetails();
  }, [userId]);

  if (!userData) return <p>Loading...</p>;

  const user = userData.user || {};
  const companies = userData.companies || [];

  return (
    <Wrapper className="container">
      <Breadcrumbs aria-label="breadcrumb" className="mb-4 mt-2 pageBreadCrumbs">
        <Link to={"/admin/users"}> Users </Link>
        <Typography sx={{ color: "text.primary" }}>{user.name}</Typography>
      </Breadcrumbs>

      <Box className="border rounded p-4">
        <div className="d-flex align-items-center gap-4">
          <div className="d-flex gap-4 w-50">
            <div>
              <UserImage>
                <img
                  src={`${BASE_API_URL}/uploads/user_profile_images/${user.profile_image}`}
                  alt={user.name}
                />
              </UserImage>
            </div>

            <div>
              <h5 className="bg_light_secondary rounded-2 px-3 py-1 d-inline txt_color_secondary"> {user.name} </h5>
              {user.role === "admin" && <Chip label="Admin" size="small" color="primary" variant="outlined" />}

              <div className="mb-1 mt-3"> <span className="fw-medium text-dark me-2 w-25 inilne">Company: </span> {user.company} </div>
              <div className="mb-1"> <span className="fw-medium text-dark me-2 w-25 inilne">Designation: </span> {user.designation} </div>
              <div className="mb-1"> <span className="fw-medium text-dark me-2 w-25 inilne">Email: </span> {user.email} </div>
              <div className="mb-1"> <span className="fw-medium text-dark me-2 w-25 inilne">Mobile Number: </span> {user.mobile} </div>
            </div>
          </div>
          <Divider orientation="vertical" flexItem />
          <div className="w-50">
            <UserStatsSec userId={user.id} />
          </div>
        </div>
      </Box>

      <h4 className="mt-5 mb-3 fw-medium text-dark">User Registered Companies</h4>

      {companies.length && companies.map((comp, idx) => (
          <UserCompShortDetails company={comp} />
        ))
      }

    </Wrapper>
  );
}

const Wrapper = styled.div`
  .pageBreadCrumbs a:hover {
    text-decoration: none;
    color: var(--secondary-color);
  }
  .txt_color_primary {
    color: #333;
  }
`;

const UserImage = styled.div`
  img {
    width: 140px;
    height: 140px;
    object-fit: cover;
    border-radius: 10px;
  }
`;
